import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../../shared';

import {
    ModelImageService,
    ModelImagePopupService,
    ModelImageComponent,
    ModelImageDetailComponent,
    ModelImageDialogComponent,
    ModelImagePopupComponent,
    ModelImageDeletePopupComponent,
    ModelImageDeleteDialogComponent,
    modelImageRoute,
    modelImagePopupRoute,
    ModelImageResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...modelImageRoute,
    ...modelImagePopupRoute,
];

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ModelImageComponent,
        ModelImageDetailComponent,
        ModelImageDialogComponent,
        ModelImageDeleteDialogComponent,
        ModelImagePopupComponent,
        ModelImageDeletePopupComponent,
    ],
    entryComponents: [
        ModelImageComponent,
        ModelImageDialogComponent,
        ModelImagePopupComponent,
        ModelImageDeleteDialogComponent,
        ModelImageDeletePopupComponent,
    ],
    providers: [
        ModelImageService,
        ModelImagePopupService,
        ModelImageResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceModelImageModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/model-image.module.ts